<script lang="ts">
	import type { IconDefinition } from "@fortawesome/free-solid-svg-icons";
	import classNames from "classnames";
	import Fa from "svelte-fa";
	import { twMerge } from "tailwind-merge";

	interface Props extends Omit<Partial<Fa["$$prop_def"]>, "icon"> {
		icon: string | IconDefinition;
		color?: string;
	}

	let { color, icon, ...rest }: Props = $props();
</script>

{#if typeof icon === "object"}
	<Fa class={twMerge(classNames("pointer-events-none", rest.class))} icon={icon} />
{:else}
	<svg class="pointer-events-none h-[1em] w-[1em]" fill={color || "currentColor"} viewBox="0 0 24 24">
		<path d={icon} />
	</svg>
{/if}
